import React from 'react';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as TimerIcon } from '../../images/timer.svg';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '30px',
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  subtitle: {
    marginTop: theme.spacing(2),
  },
  hasBank: { marginTop: theme.spacing(3) },
  bankConnected: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));

export default function AccountsComplete({ isHangTight }) {
  const classes = useStyles();

  return isHangTight ? (
    <div className={classes.bankConnected}>
      <TimerIcon />
      <Typography className={classes.title}>
        We’re on it. Hang tight!
      </Typography>
      <Typography paragraph className={classes.subtitle}>
        We’ve received your request. It will take up to 72 hours until you
        receive your custom Growth plan, but trust us - it’s worth it.
      </Typography>
    </div>
  ) : (
    <div className={classes.bankConnected}>
      <Typography variant="h4" className={classes.hasBank}>
        Well done! Bank account linked.
      </Typography>{' '}
      <Typography variant="h4" className={classes.hasBank} paragraph>
        Proceed to final step.
      </Typography>
    </div>
  );
}
